export enum ConnectionState {
    Connected = "connected",
    NotConnected = "not_connected",
    Throttled = "throttled",
}
